import { Stack, Typography } from '@mui/material';
import { DynamicIcon } from 'src/components';

export const MacroLoadingState = () => {
  return (
    <Stack alignItems="center" justifyContent="center" flex={1} padding={3}>
      <DynamicIcon name="hourglass_empty" />
      <Typography variant="body2" marginTop={1}>
        Loading macros...
      </Typography>
    </Stack>
  );
};
